<!-- 申请新商品 -->
<template>
  <div class="bg-fa">
    <div class="dyh-line-group">
      <div class="dyh-line-group-label">商 品 申 请</div>
      <el-input size="mini" placeholder="请输入内容进行模糊查询" v-model="searchValue" clearable class="input-with-select">
      </el-input>
      <el-button size="mini" @click="importExcel" style="margin-left: 20px;">导 入</el-button>
      <el-button size="mini" type="primary" @click="addLine" style="margin-left: 20px;">插 入 一 行</el-button>
      <el-button size="mini" type="primary" @click="submitGoods" style="margin-left: 20px;">提交并申请新商品</el-button>
    </div>
    <div class="dyh-body-group">
      <ve-table border-x border-y ref="goodstableRef" :columns="columns" :fixed-header="true" v-if="goodsDataShow"
        style="width: 100%; overflow: auto;" :style="`min-height:300px`" :event-custom-option="eventCustomOption"
        :maxHeight="`540px`" rowKeyFieldName="rowKey" :table-data="goods_list" :editOption="editOption"
        :cell-style-option="cellStyleOption" enable="true" />
    </div>
    <excel ref="excelRef" @update-import="getTableData" @cover-import="CoverTableData">追加并导入</excel>
    <dyhSougouImage ref="dyhSougouImageRef" @selectedImage="selectedImage"></dyhSougouImage>
    <dyh-img-choose @imageChoose="imageChoose" ref="dyhImgChooseRef"></dyh-img-choose>
  </div>
</template>
<script>

import { commonUploadImg, baseUrl } from "@/api/common.js";
import { cellStyleOption } from "@/js/sheettablecolumn.js";
import { goodsApply, goodsIsExists } from "@/api/basic.js";
import excel from '@/components/excel.vue';
import dyhSougouImage from "@/components/dyh-sougouImage.vue";
import dyhImgChoose from "@/components/dyh-imgChoose.vue";

export default {
  components: { excel, dyhSougouImage, dyhImgChoose },
  data() {
    return {
      searchValue: "",
      goodsDataShow: true,
      columns: [ // 标题第一列
        {
          field: "index",
          key: "a",
          title: "行号",
          width: "8%",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return rowIndex + 1;
          }
        },
        {
          field: "barcode",
          key: "barcode",
          title: "商品条码",
          align: "center",
          width: 150,
          edit: true,
          fixed: "center"
        }, {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "center",
          width: 150,
          edit: true,
          fixed: "center"
        }, {
          field: "advise_price",
          key: "advise_price",
          title: "建议售价",
          align: "center",
          width: 50,
          edit: true,
          fixed: "center"
        }, {
          field: "imageDesc",
          key: "imageDesc",
          title: "商品全貌",
          align: "center",
          width: 125,
          edit: false,
          fixed: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (row.imageDesc.url) {
              return (
                <div style="display:flex;justify-content:center;">
                  <img style="width:100px;height:100px;position:relative;" on-click={() => this.upLoadImage(rowIndex)} src={row.imageDesc} alt="" />
                  <div class="close" style="font-size:30px;color:red;cursor:pointer;margin-left:10px" on-click={() => { this.deleteImage(column.key, rowIndex) }}>╳</div>
                </div>
              );
            } else {
              return (
                <div style="color:#fff;display:flex;justify-content:space-around">
                  <button
                    style="background-color: #409eff !important;border:none;color:#fff;border-radius:2px;height:30px"
                    class="upload-button"
                    on-click={() => { this.chooseImage(column.key, rowIndex, row.item_name) }}
                  >
                    选择图片
                  </button>
                </div>
              )
            }
          }
        }, {
          field: "imageFront",
          key: "imageFront",
          title: "商品正面图片",
          align: "center",
          width: 125,
          fixed: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (row.imageFront.url) {
              return (
                <div style="display:flex;justify-content:center;">
                  <img style="width:100px;height:100px;position:relative;" on-click={() => this.upLoadImage(rowIndex)} src={row.imageFront} alt="" />
                  <div class="close" style="font-size:30px;color:red;cursor:pointer;margin-left:10px" on-click={() => { this.deleteImage(column.key, rowIndex) }}>╳</div>
                </div>
              );
            } else {
              return (
                <div style="color:#fff;display:flex;justify-content:space-around">
                  <button
                    style="background-color: #409eff !important;border:none;color:#fff;border-radius:2px;height:30px"
                    class="upload-button"
                    on-click={() => { this.chooseImage(column.key, rowIndex, row.item_name) }}
                  >
                    选择图片
                  </button>
                </div>
              )
            }
          }
        }, {
          field: "imageBarcode",
          key: "imageBarcode",
          title: "商品带条码图片",
          align: "center",
          width: 125,
          fixed: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if (row.imageBarcode.url) {
              return (
                <div style="display:flex;justify-content:center;">
                  <img style="width:100px;height:100px;position:relative;" on-click={() => this.upLoadImage(rowIndex)} src={row.imageBarcode} alt="" />
                  <div class="close" style="font-size:30px;color:red;cursor:pointer;margin-left:10px" on-click={() => { this.deleteImage(column.key, rowIndex) }}>╳</div>
                </div>
              );
            } else {
              return (
                <div style="color:#fff;display:flex;justify-content:space-around">
                  <button
                    style="background-color: #409eff !important;border:none;color:#fff;border-radius:2px;height:30px"
                    class="upload-button"
                    on-click={() => { this.chooseImage(column.key, rowIndex, row.item_name) }}
                  >
                    选择图片
                  </button>
                </div>
              )
            }
          }
        }, {
          field: "delete",
          key: "delete",
          title: "操作",
          width: "100px",
          center: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <button
                  style="background-color: #F56C6C !important;border:none;color:#fff;border-radius:2px;height:30px"
                  class="upload-button"
                  on-click={() => { this.deleteLine(rowIndex) }}
                >
                  删除当前行
                </button>
              </span>
            );
          }
        }],
      goods_list: [{
        rowKey: 0,
        barcode: "",
        imageFront: {},
        advise_price: 0,
        imageBarcode: {},
        imageDesc: {}

      }],
      show_goods_list: [],
      cellStyleOption: {},
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            click: (event) => {
              if (row.message) this.warnMessage(row.message);
              //
            }
          };
        }
      },
      editOption: {
        beforeStartCellEditing: ({ row, column, cellValue }) => {
          if (row.rowKey === 0 && column.field === "name") {
            alert("You can't edit this cell.");
            return false;
          }
        },
        beforeCellValueChange: async ({ row, column, changeValue }) => {
          const res = await this.judgmentBarcode(changeValue);
          if (res[0].state === true) {
            this.warnMessage("该条码库中已存在！");
            return;
          } else {
            for (let i = 0; i < this.goods_list.length; i++) {
              if (this.goods_list[i].barcode === changeValue && row.rowKey !== i) {
                this.warnMessage("重复添加该条码");
                return;
              }
            }
          }

          if (changeValue.length > 0 && (row.rowKey === 0 || row.rowKey === this.goods_list.length - 1)) {
            this.addLine();
          }
        },
        afterCellValueChange: ({ row, column, changeValue }) => {

        }
      }
    }
  },
  watch: {
    searchValue: {
      handler(n, o) {
        if (n === "") {
          this.goods_list.forEach((item, index, arr) => {
            this.$set(item, "class_state", "0")
          })
        } else this.searchGoodsList();
      }
    }

  },
  mounted() {
    this.cellStyleOption = cellStyleOption;
    //
  },
  methods: {
    /**
     * 选择图片
     * @param {string} key 当前是哪个值
     */
    chooseImage(key, rowIndex, item_name) {
      this.$refs.dyhImgChooseRef.showDyhImageCooseDialog({ key: key, index: rowIndex, item_name: item_name });
    },
    /**
     * choose组件返回值
     * @param e {object} 组件选中图片返回
     */
    imageChoose(e) {
      console.log("e-----------------------", e);
      this.$set(this.goods_list[e.index][e.key], "url", e.url);

      if (e.media_no) {
        this.$set(this.goods_list[e.index][e.key], "media_no", e.media_no);
      }
    },
    async judgmentBarcode(str) {
      // goodsIsExists();
      const res = await goodsIsExists(str);
      if (res.data && res.data.return_code === "SUCCESS" && res.data.result_code === "SUCCESS" && res.data.resp_data) {
        return res.data.resp_data;
      }
    },
    /**
     * 提交并审核单据
     */
    async submitGoods() {
      const res = await goodsApply(this.goods_list);

      if (res.data && res.data.return_code === "SUCCESS" && res.data.result_code === "SUCCESS" && res.data.resp_data) {
        const resp = res.data.resp_data;
        // let list = [];
        let unlist = [];
        for (let i = 0; i < resp.length; i++) {
          for (let j = 0; j < this.goods_list.length; j++) {
            if (this.goods_list[j].barcode === resp[i].barcode && resp[i].state === false) {
              this.$set(this.goods_list[j], 'class_state', "6");
              this.$set(this.goods_list[j], 'message', resp[i].message);
              unlist.push(this.goods_list[j]);
            }
          }
        }
        if (unlist.length > 0) {
          const l = JSON.parse(JSON.stringify(unlist));
          this.goods_list = [];
          this.goods_list = l;
          this.warnMessage("点击行查看问题！");
        } else this.successMessage("新品提交成功！");
      }
    },
    /**
     * 搜索框搜索表
     */
    searchGoodsList() {
      // let list = [];
      const searchValue = this.searchValue;
      for (let i = 0; i < this.goods_list.length; i++) {
        if (this.goods_list[i].barcode.indexOf(searchValue) > -1) {
          /* list.push(this.goods_list[i]); */
          this.$set(this.goods_list[i], 'class_state', "10");
          //this.goods_list[i].class_state = "3";
        }
      }

      //
    },
    /**
     * 打开表格导入组件
     */
    importExcel() {
      this.$refs.excelRef.showModel();//导入表格
    },
    /**
     * 插入一行
     */
    addLine() {
      this.goods_list.push({
        rowKey: this.setPersentRowKey(),
        barcode: "",
        imageFront: {},
        advise_price: 0,
        imageBarcode: {},
        imageDesc: {}
      })
    },
    /**
     * 按照索引删除一行
     * @param {number} rowIndex 需要删除的索引
     */
    deleteLine(rowIndex) {
      const that = this;
      this.$confirm('确定要删除该行吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let list = [];
        for (let i = 0; i < that.goods_list.length; i++) {
          if (i !== rowIndex) {
            list.push(that.goods_list[i]);
          }
        }
        that.goods_list = list;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    /**
     * 返回插入行的索引
     * @return {number} 返回一个最大的rowkey
     */
    setPersentRowKey() {
      let max = 0;
      for (let i = 0; i < this.goods_list.length; i++) {
        if (this.goods_list[i].rowKey >= max) {
          max = this.goods_list[i].rowKey;
        }
      }
      return max + 1
    },
    /**
     * 按照参数删除行图片
     * @param {string} key 属性值
     * @param {number} index 行索引
     */
    deleteImage(key, index) {
      this.goods_list[index][key] = "";
    },
    /**
     * 联网搜索图片组件返回
     * @param {} e {index,key,url} index-选中的索引 key-需要选择图片的列 url选中图片的索引
     */
    selectedImage(e) {
      this.goods_list[e.index][e.key] = e.url;
    },
    /**
     * 联网搜索商品
     */
    showDyhDialog(key, index, item_name) {
      this.$refs.dyhSougouImageRef.showDailog(key, index, item_name);
    },
    //TODO:上传图片 接口被修改
    uploadImg(e, index, key) {
      const that = this;
      var file_type = "";
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      file_type = e.target.files[0].type.split("/")[1]; //获取文件类型
      reader.onload = async function () {
        const res = await commonUploadImg(
          reader.result.split(",")[1],
          file_type
        );
        if (that.testR(res)) {
          const url = `${baseUrl}/media/image/${res.data.resp_data.media_no}.${file_type}`;
          that.goods_list[index][key] = url;
        }
      }
    },
    /* 返回 */
    getReturn() {

    },
    /* 关闭返回 */
    returnClose() {

    },
    upLoadImage() {

    },
    /**
     * 获取excel导入组件的数据
     */
    async getTableData(e) {
      const that = this;
      let list = []; let jlist = []; let glist = [];
      /* eslint-disable */
      let str = "";
      for (let i = 0; i < this.goods_list.length; i++) {
        if (this.goods_list[i].barcode) glist.push(this.goods_list[i].barcode);
      }
      for (let i = 0; i < e.length; i++) {
        str += e[i].barcode + ",";
      }
      const res = await this.judgmentBarcode(str);
      for (let i = 0; i < res.length; i++) {
        jlist.push(res[i].barcode.concat("#*#", res[i].state));
      }
      for (let j = 0; j < e.length; j++) {
        if (jlist.indexOf(e[j].barcode.concat("#*#false")) > -1 && glist.indexOf(e[j].barcode) == -1) {
          list.push({
            rowKey: j + that.setPersentRowKey(),
            barcode: e[j].barcode,
            item_name: e[j].item_name,
            imageFront: {},
            advise_price: e[j].advise_price,
            imageBarcode: {},
            imageDesc: {}
          })
        }
      }
      list.forEach((item, index) => {
        this.goods_list.unshift(item);
      })
    },
    /**
     * 覆盖并导入数据
     * @param e
     */
    async CoverTableData(e) {
      const that = this;
      let list = []; let jlist = [];
      /* eslint-disable */
      let str = "";
      for (let i = 0; i < e.length; i++) {
        str += e[i].barcode + ",";
      }
      const res = await this.judgmentBarcode(str);
      for (let i = 0; i < res.length; i++) {
        const str = res[i].barcode.concat("#*#", res[i].state);
        jlist.push(str);
      }
      for (let j = 0; j < e.length; j++) {
        if (jlist.indexOf(e[j].barcode.concat("#*#false")) > -1) {
          list.push({
            rowKey: j,
            barcode: e[j].barcode,
            imageFront: {},
            item_name: e[j].item_name,
            advise_price: e[j].advise_price,
            imageBarcode: {},
            imageDesc: {}
          })
        }
      }



      if (list.length === 0) {
        this.warnMessage("商品已经提交过申请！");
        return;
      }
      this.$confirm('表中现在的数据将会被覆盖，确定要覆盖导入吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.goods_list = list;
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    }
  }
}
</script>
<style lang="less" scoped>
/* .home-list{
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
} */
</style>